<template>
  <div class="home-container" v-show="iframeLoaded">
    <div class="header-company-dark">
      <span class="main-number"> {{  $t('common.mainNumber') }} {{ mainPhoneNumber}}</span>
      <span class="customer-service-number"> {{ $t('common.customerServiceNumber') }} {{ customerServicePhoneNumber }}</span>
      <span class="company-title">
        <span> {{ $t('common.welcome') }}</span>
        <span> {{ companyName }} </span>
      </span>
      <img class="turck-image" src="@/assets/general_images/armellini_truck.png">
    </div>
    <div id="beamer-dashboard-feed">
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import accountApiService from '@/api/accountService';
import authRoles from '@/utils/auth/roles';
import constants from '@/utils/constants';

window.beamer_config = {
  product_id: process.env.VUE_APP_BEAMER_PRODUCT_ID,
  selector: '#beamer-dashboard-feed',
  alert: false,
  embed: true,
  mobile: true,
  lazy: true,
  language: 'EN'
};

export default {
  data() {
    return {
      filters: {
        shipper: 'SHIPPER',
        consignee: 'CONSIGNEE',
        customer: 'CUSTOMER',
        internal: 'INTERNAL;ARMELLINI'
      },
      mainPhoneNumber: '       (800) 327 - 7887',
      customerServicePhoneNumber: ' (888) 235 - 4723',
      iframeLoaded: false,
      loading: null,
      companyName: process.env.VUE_APP_BEAMER_DEFAULT_COMPANY,
      timeoutId: null
    };
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  async mounted() {
    this.iframeLoaded = false;
    const internalUsers = [
      authRoles.ADMIN.name,
      authRoles.INTERNAL.name,
      authRoles.WAREHOUSE.name,
      authRoles.WAREHOUSE_MANAGER.name,
      authRoles.CUSTOMER_SERVICE.name,
      authRoles.ROUTING.name,
      authRoles.SUTTLE_FILE_MANAGEMENT.name,
      authRoles.SUTTLE_FILE_USERS.name
    ];

    // The users can have: SHIPPER + CUSTOMER, or CONSIGNEE + CUSTOMER, For this reason they must be in this order of precedence.
    if (this.user.roles.some(role => (internalUsers).includes(role))) {
      window.beamer_config.filter = this.filters.internal;
    }

    if (this.user.roles.some(role => ([authRoles.SHIPPER.name, authRoles.SHIPPER_DAYS_OF_SERVICE.name]).includes(role))) {
      window.beamer_config.filter = this.filters.shipper;
    }

    if (this.user.roles.some(role => role === authRoles.CONSIGNEE.name)) {
      window.beamer_config.filter = window.beamer_config.filter ? `${window.beamer_config.filter};${this.filters.consignee}` : this.filters.consignee;
    }

    if (this.user.roles.some(role => role === authRoles.CUSTOMER.name)) {
      window.beamer_config.filter = window.beamer_config.filter ? `${window.beamer_config.filter};${this.filters.customer}` : this.filters.customer;
    }

    window.beamer_config.user_email = this.user.email;
    window.beamer_config.user_firstname = this.user.name;
    window.beamer_config.onopen = this.setCompanyWelcomeMessage;
    window.beamer_config.onerror = this.redirectToOrderEntry;

    this.loading = Loading.service(constants.LOADING.DEFAULT_CONFIG);
    if (window.Beamer) {
      window.Beamer.init();
    } else {
      const beamerScript = document.createElement('script');
      beamerScript.setAttribute('src', 'https://app.getbeamer.com/js/beamer-embed.js');
      beamerScript.setAttribute('defer', 'defer');
      document.head.appendChild(beamerScript);
      beamerScript.onload = () => {
        window.Beamer.init();

        this.timeoutId = setTimeout(this.redirectToOrderEntry, 10000);
      };
    }
  },
  methods: {
    async setCompanyWelcomeMessage() {
      clearTimeout(this.timeoutId);

      // The iframe does a autoscroll, we need to control that to show the company banner(header-company-dark) correctly.
      const iframeAvoidAutoscrollingInterval = setInterval(() => {
        // Check if iframe (beamerNews) is defined
        // (We need to do that because Beamer callback and onopen they do not guarantee that the iframe is defined.)
        if (document.getElementById('beamerNews')) {
          document.getElementById('beamerNews').addEventListener('load', () => {
            this.iframeLoaded = true;
            this.loading.close();
          });
          clearInterval(iframeAvoidAutoscrollingInterval);
        }
      }, 100);

      // Only For users With type consignee or shipper with group configured.
      if (this.user.groups[0]) {
        const { data: accountsList } = await accountApiService.getAccounts({ search: this.user.groups[0] }, constants.ACCOUNTS.TYPE[0].value).catch(() => {});
        const accountSelected = accountsList.find(account => account.number === this.user.groups[0]);
        this.companyName = accountSelected.name;
      }
    },
    redirectToOrderEntry() {
      this.loading.close();
      this.$router.replace({ name: 'orderEntry' });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.home-container {
  width: 100%;
  position: relative;
  overflow: hidden;
  #beamerOverlay {
    position: inherit !important;
    .container {
      border-radius: 0px !important;
    }
  }

  #beamer-dashboard-feed {
    min-height: calc(100vh - 201px);
    transition: 0.2s all ease-out;
  }

  .header-company-dark {
    background: #00d8a6;
    color: #fff;
    background-color: #00335b !important;
    width: 100%;
    height: 145px;
    -webkit-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
    transition: 1.4s all ease-out;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: transparent;
      background: -webkit-linear-gradient(90deg,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      background: -webkit-linear-gradient(90deg,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      background: -o-linear-gradient(90deg,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      background: -webkit-gradient(linear,left top,right top,from(rgba(255,255,255,0.2)),to(rgba(0,0,0,0.2)));
      background: -webkit-linear-gradient(left,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      background: -o-linear-gradient(left,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      background: linear-gradient(90deg,rgba(255,255,255,0.2) 0,rgba(0,0,0,0.2) 100%);
      -webkit-transform: translate3d(0,0,0);
      transform: translate3d(0,0,0);
      top: 0;
      left: 0;
    }
    .main-number {
      position: absolute;
      white-space: pre;
      left: 10px;
      top: 8px;
      font-size: 12px;
      text-overflow: ellipsis;
      color: #e4eff8;
    }
    .customer-service-number {
      position: absolute;
      white-space: pre;
      left: 10px;
      top: 25px;
      font-size: 12px;
      text-overflow: ellipsis;
      color: #e4eff8;
    }
    .company-title {
      color: #ffffff !important;
      text-align: center;
      font-size: 28px;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 30px 0px 17px 20px!important;
      max-width: 55%;
      span:first-of-type {
        display: block;
        font-size: 42px;
        font-weight: bold;
      }
    }
    .turck-image {
      z-index: 1;
      width: 210px;
      height: 135px;
    }
  }
}
@media only screen and (max-width: 450px) {
  .home-container {
    #beamer-dashboard-feed {
      min-height: calc(100vh - 100px);
    transition: 0.2s all ease-out;
    }

    .header-company-dark {
      background: #00d8a6;
      color: #fff;
      background-color: #00335b !important;
      width: 100%;
      height: 45px;
      -webkit-transform: translate3d(0,0,0);
      transform: translate3d(0,0,0);
      transition: 1.4s all ease-out;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .main-number {
        display: none;
      }
      .customer-service-number {
        display: none;
      }
      .company-title {
        color: #ffffff !important;
        text-align: center;
        font-size: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 5px 0px 10px 10px!important;
        max-width: 55%;
        span:first-of-type {
          display: block;
          font-size: 12px;
          font-weight: bold;
        }
      }
      .turck-image {
        z-index: 1;
        display: none;
        width: 210px;
        height: 135px;
      }
    }
  }
}
</style>
